<template>
  <div class="groupsearch">
    <div class="search_box">
      <van-search
      v-model="value"
      show-action
      placeholder="搜索您感兴趣的群"
      :autofocus="true"
      @search="onSearch"
      @cancel="onCancel"
      shape="round"
      />
    </div>
    <div class="search_history" v-if="keylist.length>0&&showHistory">
      <div class="history_top">
        <span class="f-l f-12" style="color:#888888;">搜索历史</span>
        <span class="clean_badge" @click="cleanHistory">清除</span>
      </div>
      <div class="history_box">
        <div class="search_badge" v-for="item in keylist" :key="item" @click="clickKey(item)">{{item}}</div>
      </div>
    </div>
    <van-pull-refresh class="bbsrem" v-model="isLoading" @refresh="onRefresh" v-if="!showHistory">
      <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有群了"
      @load="onLoad"
      >
      <div class="group_cell" v-for="(item,index) in list" :key="'list_' + item.id">
        <div class="group_cell_lfet">
          <img class="group_cell_img" :src="item.img_url+item.icon">
        </div>
        <div class="group_cell_center">
          <div class="f-15">{{item.title}}</div>
          <div class="group_cell_badge">
            <div class="local_badge">
              <img class="group_local_img" :src="img.group_local">  
              {{item.region?item.region:'全国'}}
            </div>
            <div class="model_badge" :style="'background-color:'+bkColoer+ ';'" v-if="item.car_model">{{item.car_model}}</div>
            <div class="label_badge" v-if="item.label">{{item.label}}</div>
          </div>
        </div>
        <div class="group_cell_right">
          <div class="addgroupbtn" :style="'background-color:'+bkColoer+ ';'" @click="joinGroup(index)">加群</div>
        </div>
      </div>
    </van-list>
  </van-pull-refresh>
  <van-dialog v-model="showEq" :show-confirm-button="false" :show-cancel-button="false" close-on-click-overlay>
    <div class="eq_box">
      <div style="padding:15px 15px 10px 15px;">
        <div class="eq_info">
          <img class="eq_info_icon" :src="info.img_url+info.icon">
          <div class="eq_info_title van-ellipsis">{{info.title}}</div>
          <div class="eq_info_close" @click='showEq=false'><van-icon name="cross" /></div>
        </div>
        <img class="eq_img" fit="cover" :src="info.img_url+info.img">
        <div class="eq_click"><img class="group_click" :src="img.group_click">长按识别二维码进群</div>
      </div>
      <div class="eq_safe" :style="'background-color:'+bkColoer+ ';'"><img class="group_safe" :src="img.group_safe">安全认证</div>
    </div>
  </van-dialog>
</div>
</template>
<script>
  import content from '../../api/content';
  import wxShare from '../../api/wxShare';
  import { mapState } from 'vuex';
  import { List,Search,PullRefresh,Dialog } from 'vant';
  export default {
    data () {
      return {
        value:'',
        keylist:[],
        showHistory:true,
        isLoading:false,
        loading:false,
        finished:false,
        list:[],
        showEq:false,
        info:'',
        params:{
          page:1,
          size:10
        },
        img:{
          group_local:require('../../assets/img/lexus/my/location.png'),
          group_safe:require('../../assets/img/group_safe.png'),
          group_click:require('../../assets/img/group_click.png'),
          group_close:require('../../assets/img/group_close.png'),
        }
      }
    },
    created () {
      this.media_id = this.$route.query.media_id?this.$route.query.media_id:0
      if(localStorage.getItem('searchKey')){
        var key=localStorage.getItem('searchKey')
        this.keylist = key.split(",")
      }
      if(this.media_id==2){//VTEC
        this.bkColoer='#AA0000'
        var params={
          title:'VTEC范儿官方车友群',
          description:'点击查看更多热门新车群',
          pic_url:'https://pic.motortime.com/logo/vtec.png'
        }
        }else if(this.media_id==3){//富士
          this.bkColoer='#1F2A74'
          var params={
            title:'富士范儿官方车友群',
            description:'点击查看更多热门新车群',
            pic_url:'https://pic.motortime.com/logo/subru.png'
          }
        }else if(this.media_id==4){//华系范儿
          var params={
            title:'华系范儿官方车友群',
            description:'点击查看更多热门新车群',
            pic_url:'https://pic.motortime.com/logo/huaxi.jpg'
          }
        }else if(this.media_id==5){//波子
          var params={
            title:'波子范儿官方车友群',
            description:'点击查看更多热门新车群',
            pic_url:'https://pic.motortime.com/logo/porsche.png'
          }
        }else if(this.media_id==6){//凌志
          this.bkColoer='#605C6B'
          var params={
            title:'凌志范儿官方车友群',
            description:'点击查看更多热门新车群',
            pic_url:'https://pic.motortime.com/logo/lexus.jpg'
          }
        }else if(this.media_id==7){//富豪
          var params={
            title:'富豪范儿官方车友群',
            description:'点击查看更多热门新车群',
            pic_url:'https://pic.motortime.com/logo/volvo.png'
          }
        }else{
          this.bkColoer='#F6AB00'
          var params={
            title:'汽车时间官方车友群',
            description:'点击查看更多热门新车群',
            pic_url:'https://pic.motortime.com/logo/motortime.png'
          }
        }

        content.getShare({url:encodeURI(location.href)}).then(res => {
          if(res.data.state == 1) {
           wxShare.getJSSDK(res.data.data, params)
         }
       })
      },
      methods: {
        onSearch(e){
          this.value=e
          this.showHistory=false
          if (e) {
            this.finished = false;
            this.list=[]
            this.params.page=1
            this.isLoading = true;
          // this.onLoad();
          if (localStorage.getItem('searchKey')) {
            var localkey=localStorage.getItem('searchKey')
            var key = localkey
            var keylist = []
            keylist = key.split(",")

            if (keylist.indexOf(e) > -1) {
              var num = keylist.indexOf(e)
              keylist.splice(num, 1)
            }
            var old_key = keylist.join(",")
            var key = e + ',' + old_key
            localStorage.setItem("searchKey", key);
          } else {
            localStorage.setItem("searchKey", e);
          }
        }
      },
      onCancel(){
        this.value=''
        this.showHistory=true
        this.finished = false;
        this.list=[]
        this.params.page=1
        this.isLoading = true;
        this.$router.push({path: '/grouplist?media_id=' + this.media_id});
        // this.$router.push({name: "GroupList"})
      },
      cleanHistory(){
        this.keylist=[]
        localStorage.removeItem('searchKey')
      },
      
      joinGroup(index){
        this.info=this.list[index]
        this.showEq=true
      },
      clickKey(title){
        this.value=title
        this.showHistory=false
        var localkey=localStorage.getItem('searchKey')
        var key = localkey
        var keylist = []
        keylist = key.split(",")

        if (keylist.indexOf(title) > -1) {
          var num = keylist.indexOf(title)
          keylist.splice(num, 1)
        }
        var old_key = keylist.join(",")
        var key = title + ',' + old_key
        localStorage.setItem("searchKey", key);
      },
      onLoad() {
        setTimeout(() => {
          this.params.media_id=this.media_id
          console.log('media_id==='+this.media_id)
          this.params.title=this.value
          content.getGroupList(this.params).then(res => {
            this.list.push.apply(this.list, res.data.data.data)
            this.params.page += 1
            this.total = res.data.data.total
            this.loading = false
            this.isLoading = false;
            if(res.data.data.data.length == 0) {
              this.finished = true
            }
          })
        }, 500);
      },
      onRefresh() {
      // 清空列表数据
      this.finished = false;
      this.list=[]
      this.params.page=1
      this.isLoading = true;
      this.onLoad();

    },
  },
  components: {

    [List.name]:List,
    [Search.name]:Search,
    [PullRefresh.name]:PullRefresh,
    [Dialog.name]:Dialog
  }
}
</script>
<style lang="scss">
.groupsearch{
  .search_box{
    padding:5px 0;
    border-bottom: 1px solid #eaeaea;
  }
  .search_history {
    padding: 15px;
  }

  .history_top {
    min-height: 30px;
  }

  .clean_badge {
    float: right;
    font-size: 12px;
    background-color: #f2f2f2;
    color: #2a2a2a;
    border-radius: 30px;
    padding: 2px 10px;
  }

  .search_badge {
    background-color: #f2f2f2;
    color: #2a2a2a;
    font-size: 13px;
    padding: 5px 10px;
    border-radius: 30px;
    margin: 10px 10px 10px 0;
    display: inline-block;
  }
  .listnum{
    padding: 10px 0 0 15px;
    font-size: 10px;
    font-weight: 600;
  }
  .group_cell{
    display: flex;
    align-items:center;
    padding:10px;
    border-bottom:1px solid #eaeaea;
    .group_cell_lfet{
      float: left;
      height: 62px;
      .group_cell_img{
        width: 62px;
        height: 62px;
      }
    }
    .group_cell_center{
      flex: 1;
      margin-left: 15px;
      .group_cell_title{
       font-family: PingFangSC-Medium;
       font-size: 14px;
       color: #343435;
       font-weight: 500;
     }
     .group_cell_badge{
      display: flex;
      align-items:center;
      margin-top: 8px;
      .local_badge {
        display: flex;
        align-items: center;
        background-color: #7C7A7A;
        color: #fff;
        padding: 0 5px;
        font-size: 8px;
        height: 18px;
        opacity: 0.65;
      }

      .group_local_img {
        width: 8px;
        height: 10px;
        margin-right: 3px;
      }

      .model_badge {
        color: #fff;
        padding: 0 5px;
        font-size: 8px;
        margin-left: 5px;
        height: 18px;
        display: flex;
        align-items:center;
        opacity: 0.65;
      }

      .label_badge {
        background-color: #7C7A7A;
        color: #fff;
        padding: 0 5px;
        font-size: 10px;
        margin-left: 5px;
        height: 18px;
        display: flex;
        align-items:center;
      }
    }
  }
  .group_cell_right{
    float: right;
    .addgroupbtn{
      color: #ffffff;
      font-weight: 400;
      font-size: 12px;
      width: 60px !important;
      padding: 6px 5px;
      text-align: center;
    }
  }
}
.van-dialog{
  width: 85%;
  border-radius:4px;
}
.eq_box {
  -webkit-touch-callout:none;
  -webkit-user-select:none;
  -khtml-user-select:none;
  -moz-user-select:none;
  -ms-user-select:none;
  user-select:none;
  border-radius:4px;
  background-color: #fff;
  text-align: center;
  .eq_info{
    display: flex;
    align-items:center;
    position:relative;
    .eq_info_icon{
      width: 60px;
      height: 60px;
      margin-right: 10px;
    }
    .eq_info_title{
      font-size: 15px;
      flex: 1;
      text-align: left;
    }
    .eq_info_close{
      position:absolute;
      top:-15px;
      right: -15px;
      font-size: 15px;
      padding: 15px;
    }
  }
  .eq_img{
    width: 250px;
    height: 250px;
    margin-top: 15px;
  }
  .eq_click{
    font-size: 15px;
    font-weight: 500;
    display: flex;
    align-items:center;
    justify-content: center;
    .group_click{
      width: 51px;
      height: 51px;
      margin-right: 5px;
    }
  }
  .eq_safe{
    color: #fff;
    font-size: 15px;
    padding:10px 0;
    display: flex;
    align-items:center;
    justify-content: center;
    .group_safe{
      width: 21px;
      height: 21px;
    }
  }
}
}
</style>
